import { memo } from "react";
import Typography, { type TypographyProps } from "@mui/material/Typography";

const OnboardingTypography = (props: TypographyProps) => (
    <Typography
        {...props}
        sx={{
            fontWeight: 400,
            fontStyle: 'normal',
            fontSize: 20,
            lineHeight: '100%',
            letterSpacing: 0,
            ...props.sx
        }}
    />
);

export default memo(OnboardingTypography);
